import styled from '@emotion/styled';
import { useAuth, usePalette } from 'src/hooks';
import { transientOptions } from 'src/utils';
import { Divider, Typography } from 'src/components/atoms';

type Size = 'small' | 'medium';

interface Props {
  size?: Size;
}

interface StyledContainerProps {
  $size: Size;
}
const StyledNameContainer = styled('div', transientOptions)<StyledContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: ${props => (props.$size === 'small' ? '10rem' : '15rem')};
  padding: 0.25rem;
`;

const StyledUserName = styled(Typography)`
  max-width: 98%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;

export const ProfileNameContainer = ({ size = 'small' }: Props) => {
  const { grey } = usePalette();
  const { user } = useAuth();

  const typographyVariant = size === 'small' ? 'body2' : 'h5';

  if (!user) {
    return null;
  }

  return (
    <StyledNameContainer $size={size}>
      <StyledUserName variant={typographyVariant}>{user.fullName}</StyledUserName>
      <Divider flexItem sx={{ borderColor: grey['500'], mx: '-1rem' }} />
      {user.displayName && <Typography variant={typographyVariant}>{user.displayName}</Typography>}
    </StyledNameContainer>
  );
};
